import React, { memo, useMemo, useState } from 'react';
import './Realisations.css';

import clim1 from '../assets/realisation/clim 1.webp';
import clim2 from '../assets/realisation/clim2.webp';
import clim3 from '../assets/realisation/clim3.webp';
import clim4 from '../assets/realisation/clim4.webp';
import clim5 from '../assets/realisation/clim5.webp';
import clim6 from '../assets/realisation/clim6.webp';

import pompe1 from '../assets/realisation/pompe1.webp';
import pompe2 from '../assets/realisation/pompe2.webp';
import pompe3 from '../assets/realisation/pompe3.webp';

import climService    from '../assets/entretientService.jpg';
import entretienService1 from '../assets/entretienService1.jpg';
import entretienService2 from '../assets/entretienService2.jpg';
import pompeService   from '../assets/pompeService.jpg';

const PROJECTS = [
  { id: 1,  category: 'Climatisation',   image: clim1 },
  { id: 2,  category: 'Climatisation',   image: clim2 },
  { id: 3,  category: 'Climatisation',   image: clim3 },
  { id: 4,  category: 'Climatisation',   image: clim4 },
  { id: 5,  category: 'Climatisation',   image: clim5 },
  { id: 6,  category: 'Climatisation',   image: clim6 },

  { id: 7,  category: 'Pompe à chaleur', image: pompe1 },
  { id: 8,  category: 'Pompe à chaleur', image: pompe2 },
  { id: 9,  category: 'Pompe à chaleur', image: pompe3 },

  { id: 10, category: 'Services',        image: climService },
  { id: 12, category: 'Services',        image: entretienService1 },
  { id: 13, category: 'Services',        image: entretienService2 },
];

const FILTERS = ['Tous', 'Climatisation', 'Pompe à chaleur', 'Services'];

const PROJECTS_BY_FILTER = {
  Tous: PROJECTS,
  Climatisation:     PROJECTS.filter((p) => p.category === 'Climatisation'),
  'Pompe à chaleur': PROJECTS.filter((p) => p.category === 'Pompe à chaleur'),
  Services:          PROJECTS.filter((p) => p.category === 'Services'),
};

const RealisationCard = memo(function RealisationCard({ project, priority = false }) {
  return (
    <article className="realisations__card">
      <div className="realisations__media">
        <img
          src={project.image}
          alt={project.category}
          className="realisations__image"
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
          fetchPriority={priority ? 'high' : 'auto'}
          draggable="false"
        />
        <div className="realisations__overlay" />
        <span className="realisations__badge">{project.category}</span>
      </div>
    </article>
  );
});

const FilterButton = memo(function FilterButton({ item, active, onClick }) {
  return (
    <button
      className={`realisations__filter ${active ? 'realisations__filter--active' : ''}`}
      onClick={onClick}
      type="button"
    >
      {item}
    </button>
  );
});

export default function Realisations() {
  const [filter, setFilter] = useState('Tous');

  const filteredProjects = useMemo(() => {
    return PROJECTS_BY_FILTER[filter] || PROJECTS;
  }, [filter]);

  return (
    <section id="realisations" className="realisations">
      <div className="container">
        <div className="realisations__header">
          <div className="about__label">NOS RÉALISATIONS</div>
          <h2 className="section-title realisations__title">
            QUELQUES-UNES DE NOS
            <br />
            <span className="realisations__accent">INSTALLATIONS</span>
          </h2>
        </div>

        <div className="realisations__filters" role="tablist" aria-label="Filtrer les réalisations">
          {FILTERS.map((item) => (
            <FilterButton
              key={item}
              item={item}
              active={filter === item}
              onClick={() => setFilter(item)}
            />
          ))}
        </div>

        <div className="realisations__grid">
          {filteredProjects.map((project, index) => (
            <RealisationCard
              key={project.id}
              project={project}
              priority={index < 2}
            />
          ))}
        </div>
      </div>
    </section>
  );
}